import abstractModel from '../../core/MercatelyModel';
import { serializeParams } from '../../util/urlUtils';

const csrfToken = document.querySelector('[name=csrf-token]').content;
const getResource = (agentId) => `/api/mia/chatbot/agents/${agentId}/tools`;

const model = abstractModel('');
const parentGet = model.get;
const parentSave = model.save;
const parentPut = model.put;
const parentDelete = model.remove;

model.get = (agentId, params = {}) => {
  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const hasArrayParams = Object.values(params).some(value => Array.isArray(value));

    if (hasArrayParams) {
      const queryString = serializeParams(params);
      return parentGet({}, { path: getResource(agentId), filters: queryString });
    }
  }

  return parentGet(params, { path: getResource(agentId) });
};

model.retrieve = (agentId, toolId) => {
  return parentGet({}, { path: `${getResource(agentId)}/${toolId}` });
};

model.save = (agentId, data) => {
  return parentSave(data, { path: getResource(agentId), csrfToken });
};

model.update = (agentId, toolId, data) => {
  return parentPut(data, { path: `${getResource(agentId)}/${toolId}`, csrfToken });
};

model.updateByType = (agentId, toolType, data) => {
  return parentPut(data, { path: `${getResource(agentId)}/type/${toolType}`, csrfToken });
};

model.delete = (agentId, toolId) => {
  return parentDelete({ id: toolId }, { path: getResource(agentId), csrfToken });
};

export default model;
